import { render, staticRenderFns } from "./economy-total2.vue?vue&type=template&id=47ea7346&scoped=true"
import script from "./economy-total2.vue?vue&type=script&lang=js"
export * from "./economy-total2.vue?vue&type=script&lang=js"
import style0 from "./economy-total2.vue?vue&type=style&index=0&id=47ea7346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ea7346",
  null
  
)

export default component.exports